// resources/js/Components/zone/ManualScheduleForm.jsx
import React from 'react';
import {
    Grid,
    TextField,
    IconButton,
    Checkbox,
    FormControlLabel,
    Button,
    Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const daysOfWeek = [
    { label: 'Mo', value: 0 },
    { label: 'Tu', value: 1 },
    { label: 'We', value: 2 },
    { label: 'Th', value: 3 },
    { label: 'Fr', value: 4 },
    { label: 'Sa', value: 5 },
    { label: 'Su', value: 6 },
];

const ManualScheduleForm = ({ schedule, setSchedule }) => {
    const handleChange = (index, field, value) => {
        const updated = schedule.map((entry) => ({ ...entry }));
        updated[index][field] = value;
        setSchedule(updated);
    };

    const handleDayToggle = (index, day) => {
        const updated = schedule.map((entry) => ({ ...entry }));
        const days = updated[index].days || [];
        updated[index].days = days.includes(day)
            ? days.filter((d) => d !== day)
            : [...days, day];
        setSchedule(updated);
    };

    const handleAdd = () => {
        setSchedule([...schedule, { start: '00:00', stop: '23:59', days: [] }]);
    };

    const handleRemove = (index) => {
        const updated = schedule.filter((_, i) => i !== index);
        setSchedule(updated);
    };

    return (
        <Box>
            {schedule.map((item, index) => (
                <Grid container spacing={2} alignItems="center" key={index} sx={{ mb: 1 }}>
                    <Grid item xs={5}>
                        <TextField
                            type="time"
                            label="Start"
                            value={item.start}
                            fullWidth
                            onChange={(e) => handleChange(index, 'start', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ step: 300 }}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <TextField
                            type="time"
                            label="Stop"
                            value={item.stop}
                            fullWidth
                            onChange={(e) => handleChange(index, 'stop', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ step: 300 }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <IconButton onClick={() => handleRemove(index)} color="error">
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display="flex" gap={1} flexWrap="wrap">
                            {daysOfWeek.map(({ label, value }) => (
                                <FormControlLabel
                                    key={value}
                                    control={
                                        <Checkbox
                                            checked={item.days?.includes(value) || false}
                                            onChange={() => handleDayToggle(index, value)}
                                        />
                                    }
                                    label={label}
                                />
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            ))}
            <Box mt={2}>
                <Button onClick={handleAdd} variant="outlined">Add Interval</Button>
            </Box>
        </Box>
    );
};

export default ManualScheduleForm;
